import { BaseFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/base-format.adapter';
import { ZendeskSettings } from 'app/model/dataflow/dataset-settings/zendesk-settings';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(ZendeskSettings)
})
export class ZendeskAdapter extends BaseFormatAdapter<ZendeskSettings> {
    public async toSourceDSL(setting: ZendeskSettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.Zendesk}'`);
        props.push(`format: 'rest'`);
        if (setting.entity.expression) {
            props.push(`entity: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.entity)}`);
        }
        return props;
    }

    public async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<ZendeskSettings> {
        const setting = this._generateSetting(owner);
        if (configs.has('entity')) {
            setting.entity = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('entity'), owner);
            handledConfigs.push('entity');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): ZendeskSettings {
        const setting = Owned.create<ZendeskSettings>(ZendeskSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
